import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


const translations = {
  en: require('../../../Translate/en.json').VisualProduction.EventServices,
  ar: require('../../../Translate/ar.json').VisualProduction.EventServices,
};

const EventServices = () => {
  const { i18n } = useTranslation();
    const isLang = i18n.language;
  const t = translations[isLang || 'en'];

  return (
    <Row  >
      {/* ✅ تغطية الفعاليات */}
      <Col xs={12} md={12}>
        <h2 className={`section-title ${isLang == "en" ? 'text-start' : 'text-end'}`}>{t.EventsCoverage.title}</h2>
        <ul className={`service-list ${isLang == "en" ? 'text-start' : 'text-end'}`}>
          {Object.keys(t.EventsCoverage.services).map((key, index) => (
            <li key={index}>
              <strong>{t.EventsCoverage.services[key].title}:</strong> {t.EventsCoverage.services[key].description}
            </li>
          ))}
        </ul>
      </Col>

      {/* ✅ خدمات البث المباشر */}
      <Col xs={12} md={12}>
        <h2 className={`section-title mt-5 ${isLang == "en" ? 'text-start' : 'text-end'}`}>{t.LivestreamServices.title}</h2>
        <ul className={`service-list ${isLang == "en" ? 'text-start' : 'text-end'}`}>
          {Object.keys(t.LivestreamServices.services).map((key, index) => (
            <li key={index}>
              <strong>{t.LivestreamServices.services[key].title}:</strong> {t.LivestreamServices.services[key].description}
            </li>
          ))}
        </ul>
      </Col>
    </Row>
  );
};

export default EventServices;
